import script from "./PrivacyConsentField.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyConsentField.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyConsentField.vue?vue&type=style&index=0&id=2552de9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2552de9f"]])

export default __exports__